import React, {type ReactNode} from 'react';
type Props = {
  type: 'secondary' | 'info' | 'warning' | 'danger';
  icon: string;
  title: ReactNode;
  content?: ReactNode;
  actionContent?: ReactNode;
  onClose?: () => void;
};
export const DocumentAlertBox = ({
  icon,
  title,
  content,
  actionContent,
  type,
  onClose,
}: Props) => (
  <div className={`alert alert-${type}`}>
    <div className="row">
      <h4 className="col-auto">
        <i className={`fa fa-fw ${icon}`} />
      </h4>
      <div className="col pl-0">
        <div className="row">
          <div className="col-12 col-md">
            <h4 className="alert-heading">
              {title}
              {onClose != null ? (
                <button type="button" className="close" onClick={onClose}>
                  <span>&times;</span>
                </button>
              ) : null}
            </h4>
            {content != null ? (
              <>
                <hr className="my-2" />
                {content}
              </>
            ) : null}
          </div>
          {actionContent != null ? (
            <div className="col-auto mt-2 mt-md-0 pl-3 pl-md-0 d-flex align-items-center">
              {actionContent}
            </div>
          ) : null}
        </div>
      </div>
    </div>
  </div>
);
